export default __webpack_public_path__ + "static/hero_business_back_img_5-9b66ef182d69aa5178b98ddaac5c229f.png";